(() => {
  const state = new WeakMap();

  function init(container) {
    if (state.has(container)) return state.get(container);

    const root = container.shadowRoot || container;

    const variantSelects = root.querySelectorAll('.product-variants--select select.product-variant-container');
    const qtySelect = root.querySelector('select[name="quantity"]');
    const hiddenInput = root.querySelector('input[name="id"]');
    const variantsScript = root.querySelector('script[type="application/json"]');

    // Wenn kein qtySelect da ist, sparen wir uns die ganze Logik
    // (Schnellkauf kann trotzdem funktionieren)
    let variantsData = [];
    if (variantsScript) {
      try { variantsData = JSON.parse(variantsScript.textContent || '[]'); } catch (_) {}
    }

    function getSelectedVariant() {
      if (!variantsData.length) return null;
      const selectedOptions = Array.from(variantSelects).map(s => s.value);

      return variantsData.find(v => {
        for (let i = 0; i < selectedOptions.length; i++) {
          const key = 'option' + (i + 1);
          if (v[key] != selectedOptions[i]) return false;
        }
        return true;
      }) || null;
    }

    function updateHiddenVariantId(variant) {
      if (hiddenInput && variant && variant.id) hiddenInput.value = variant.id;
    }

    function rebuildQtyOptions(maxQty) {
      if (!qtySelect) return;

      // Sicherheitslimit – dein Code hatte 250, das bleibt:
      maxQty = Math.max(1, Math.min(250, maxQty || 1));

      // Wenn schon korrekt aufgebaut, nix tun
      const currentCount = qtySelect.options.length;
      if (currentCount === maxQty) return;

      // Rebuild (einmalig, aber erst bei Interaktion)
      qtySelect.innerHTML = '';
      const frag = document.createDocumentFragment();
      for (let i = 1; i <= maxQty; i++) {
        const opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = String(i);
        frag.appendChild(opt);
      }
      qtySelect.appendChild(frag);
    }

    function updateFromSelection() {
      const v = getSelectedVariant();
      if (!v) return;

      updateHiddenVariantId(v);

      // Quantity nur dann rebuilden, wenn wir ein qtySelect haben.
      // Das passiert erst durch Events (siehe unten), NICHT beim Seitenload.
      if (qtySelect) {
        rebuildQtyOptions(v.inventory_quantity);
      }
    }

    // Listener nur für dieses Produkt (und erst nach init)
    variantSelects.forEach(sel => {
      sel.addEventListener('change', updateFromSelection, { passive: true });
    });

    // Quantity-Dropdown erst dann befüllen, wenn der User es wirklich anfasst
    if (qtySelect) {
      qtySelect.addEventListener('focus', updateFromSelection, { passive: true });
      qtySelect.addEventListener('pointerdown', updateFromSelection, { passive: true });
    }

    const api = { updateFromSelection };
    state.set(container, api);
    return api;
  }

  // Event Delegation: wir initialisieren pro Produkt erst bei Interaktion
  function findContainer(el) {
    return el && el.closest && el.closest('product-form[data-quick-buy="true"]');
  }

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.matches && t.matches('select.product-variant-container')) {
      const c = findContainer(t);
      if (!c) return;
      init(c).updateFromSelection();
    }
  }, true);

  document.addEventListener('pointerdown', (e) => {
    const t = e.target;
    if (!t) return;

    // Klick auf Schnellkauf / Qty / Varianten → init
    if (
      (t.matches && (t.matches('[data-js-product-add-to-cart]') || t.matches('select[name="quantity"]'))) ||
      (t.closest && (t.closest('[data-js-product-add-to-cart]') || t.closest('select[name="quantity"]')))
    ) {
      const c = findContainer(t);
      if (!c) return;
      init(c).updateFromSelection();
    }
  }, true);
})();